export default function ({ store, route }) {
  if (!location.search || location.search !== "?backstopjs=true") {
    document.documentElement.classList.add("enable-animations");
  }
}
